import {ChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {SortAscIcon, SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

import {TEST_IDS} from '../../constants/test-ids'

const sortConfigs = {
  [ChronologicalCommentsSort.OldestFirst]: {shortLabel: 'Oldest', label: 'Oldest first', Icon: SortAscIcon},
  [ChronologicalCommentsSort.NewestFirst]: {shortLabel: 'Newest', label: 'Newest first', Icon: SortDescIcon},
} as const

const availableSorts = [ChronologicalCommentsSort.NewestFirst, ChronologicalCommentsSort.OldestFirst] as const

type CommentsSortMenuProps = {
  sort: ChronologicalCommentsSort
  onSortChange: (sort: ChronologicalCommentsSort) => void
  subject?: 'comments' | 'activity'
  iconOnly?: boolean
}

export function CommentsSortMenu({
  sort: currentSort,
  onSortChange,
  subject = 'comments',
  iconOnly = false,
}: CommentsSortMenuProps) {
  const {Icon: CurrentSortIcon, shortLabel: currentSortLabel} = sortConfigs[currentSort]
  const ariaLabel = `Sort ${subject}: ${currentSortLabel}`
  const testId = subject === 'activity' ? TEST_IDS.activitySortMenuButton : TEST_IDS.commentsSortMenuButton

  return (
    <ActionMenu>
      {iconOnly ? (
        <ActionMenu.Anchor>
          <IconButton icon={CurrentSortIcon} variant="invisible" aria-label={ariaLabel} data-testid={testId} />
        </ActionMenu.Anchor>
      ) : (
        <ActionMenu.Button leadingVisual={CurrentSortIcon} aria-label={ariaLabel} data-testid={testId}>
          {currentSortLabel}
        </ActionMenu.Button>
      )}
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single">
          {availableSorts.map(sort => {
            const {label, Icon} = sortConfigs[sort]
            return (
              <ActionList.Item key={sort} selected={sort === currentSort} onSelect={() => onSortChange(sort)}>
                <ActionList.LeadingVisual>
                  <Icon />
                </ActionList.LeadingVisual>
                {label}
              </ActionList.Item>
            )
          })}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
